<template>
  <div class="user_info">
    <h3>親愛的會員，請填寫真實資料，有助於好友找到你哦。</h3>
    <div class="details">
      <el-row v-for="item in userInfoList" :key="item.name">
        <el-col :span="isPc?4:6" class="tag">{{item.name}}</el-col>
        <el-col :span="isPc?16:14">
          <div v-if="item.type=='member_photo'">
            <el-upload
              class="avatar-uploader"
              action="https://upload-z0.qiniup.com"
              :data="qn"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="item.value" :src="$imgUrl+item.value" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div v-else-if="item.type=='isopen'">
            <el-switch
              v-model="item.value==0?true:false"
              active-color="#4f4e95"
              inactive-color="#ccc"
              @change="changeSwitch"  
            >
            </el-switch>
          </div>
          <div v-else-if="item.type=='member_address'" class="member_address">
            <v-distpicker :placeholders="placeholders" :province="province_id" :city="city_id" :area="area_id" @selected='selected'></v-distpicker>
            <el-input v-model="item.value" placeholder="詳細地址：如道路、小區、單元室等"></el-input>
          </div>
          <div v-else-if="item.type=='member_phone'">
            <!-- 不可修改 -->
            <el-input v-model="item.value" :placeholder="item.value"></el-input>
          </div>
          <div v-else> 
            <el-input v-model="item.value" :placeholder="'請輸入'+item.name"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-button class="save_btn" type="primary" @click="submitUserInfoUpdate">保存</el-button>
      <el-button type="info"  plain @click="outLogin">退出登錄</el-button>
    </div>
  </div>
</template>

<script>
import VDistpicker from 'v-distpicker'
import {mapState} from 'vuex'
import * as qiniu from 'qiniu-js'
export default {
  components: { VDistpicker },
  data() {
    return {
      scrollTop:'',
      qn: {
        token: "",
        key: 'avatar_' + Date.now() + '_' + Math.random()
      },
      placeholders: {
        province: '------- 省 --------',
        city: '--- 市 ---',
        area: '--- 區 ---',
      },
      province_id:'',
      city_id:'',
      area_id:'',
      userInfoList:[
        {
          name:'頭像',
          value:'',
          type:'member_photo'
        },
        {
          name:'姓名',
          value:'',
          type:'member_name'
        },
        {
          name:'聯繫方式',
          value:'',
          type:'member_phone'
        },
        {
          name:'是否公開聯繫方式',
          value:1,
          type:'isopen'
        },
        {
          name:'地址',
          value:'',
          type:'member_address'
        },
        {
          name:'郵箱',
          value:'',
          type:'member_email'
        },
        {
          name:'微信',
          value:'',
          type:'wechat_id'
        },
        {
          name:'Facebook',
          value:'',
          type:'facebook'
        },
        {
          name:'個性簽名',
          value:'',
          type:'person_intro'
        }
      ]
    };
  },
  computed: {
    ...mapState(['isPc','userInfo','user_id']),
    submitData(){
      let submitDataRes={}
      this.userInfoList.map(item => {
        submitDataRes[item.type]=item.value
      })
      return submitDataRes
    },
  },
  watch:{
    userInfo(val,oldval){
      this.userInfoList.map(item => {
        item.value=val[item.type]
      })
      this.province_id=val.province_id
      this.city_id=val.city_id
      this.area_id=val.area_id
    }
  },
  methods:{
    handleAvatarSuccess(res, file) {
      // this.userInfoList[0].value = URL.createObjectURL(file.raw);
      this.fnUploadFile(file.raw)
      // console.log(file)
    },
    beforeAvatarUpload(file) {
      // console.log('文件大小======',file)
      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isLt6M = file.size / 1024 / 1024 < 6;

      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error("上傳頭像圖片只能是jpg、png、jpeg格式!");
        return false;
      }
      if (!isLt6M) {
        this.$message.error("上傳頭像圖片大小不能超過 6MB!");
        return false;
      }
    },
    //上传图片至七牛云
    fnUploadFile(raw) {
      let vm = this;
      let key = 'avatar_' + Date.now() + '_' + Math.random();
      let file = raw;
      var putExtra = {
        fname: key,
        mimeType: ["image/png", "image/jpeg", "image/gif"]//限制上传类型
      };
      let config = {
        useCdnDomain: true,
        region: qiniu.region.z0
      };
      let observer = {
        next(res){
          // ...
        },
        error(err){
          // console.log('失败====',err);
        },
        complete(res){
          // console.log('上传图片====',JSON.stringify(res))
          vm.userInfoList[0].value = res.key
        }
      }
      var observable = qiniu.upload(file, key, this.qn.token, putExtra, config)
      var subscription = observable.subscribe(observer) // 上传开始
    },
    async getQiniuToken() {
      const { data: res } = await this.$http.get(`/api/v2/qiniu/getUptoken`)
      if(!res.sucess) return this.$message.error('獲取失敗')
      this.qn.token=res.data
      // console.log('七牛云=====',res)
    },
    changeSwitch(e){
      // console.log('七牛云=====',e)
      this.userInfoList[3].value=e?0:1
      this.submitData.isopen=e?0:1
      this.updateIsOpenState()
    },
    async updateIsOpenState() {
      const { data: res } = await this.$http.get(`/api/v2/member/${this.user_id}/privacy`)
      if(!res.sucess) return this.$message.error('修改失敗')
      // this.$message.success('修改sss成功')
      // this.userInfo=res.data
    },
    async submitUserInfoUpdate() {
      // alert('更新'+JSON.stringify(data))
      this.submitData.member_id=this.user_id
      this.submitData.province_id=this.province_id
      this.submitData.city_id=this.city_id
      this.submitData.area_id=this.area_id
      // console.log('submitData====',this.submitData)
      const { data: res } = await this.$http.post(`/api/v2/member/update`,this.submitData)
      if(!res.sucess) return this.$message.error('獲取失敗')
      this.$message.success('修改成功')
      // console.log('修改头像=====',res)
    },
    selected(data){
      // console.log('选择地址=====',data)
      this.province_id=data.province.value
      this.city_id=data.city.value
      this.area_id=data.area.value
    },
    async outLogin() {
      const { data: res } = await this.$http.post(`/api/v2/account/outLogin/${window.sessionStorage.getItem("token")}`)
      if(!res.sucess) return this.$message.error('獲取失敗')
      this.$message.success('退出成功')
      // this.backTop();
      this.$store.state.validToken=false
      this.$router.push({
        path: `/`,
      })
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      let that = this;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 0) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
  },
  created(){
    this.getQiniuToken()
  },
  mounted() {
    // console.log(this.userInfo)
    if (this.userInfo){
      this.userInfoList.map(item => {
        item.value=this.userInfo[item.type]
      })
      this.province_id=this.userInfo.province_id
      this.city_id=this.userInfo.city_id
      this.area_id=this.userInfo.area_id
    }
    
  }
}
</script>

<style lang="less" scoped>
  .user_info{
    margin-left: 20px;
    border: 1px solid #EBEAEB;
    padding: 40px;
    flex: 1;
    margin-bottom: 40px;
    h3{
      font-size:18px;
      font-weight:400;
      color:#333333;
      line-height:22px;
    }
    .el-row {
      margin-top: 20px;
      .tag{
        font-size:16px;
        font-weight:400;
        color:#666;
      }
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 44px;
        color: #E4E4E4;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        background: #F6F6F6;
      }
      .avatar {
        width: 100px;
        height: 100px;
        display: block;
      }
      .member_address{
        .el-input{
          margin-top: 10px;
        }
      }
    }
    .save_btn{
      background: #4f4e95!important;
      border: none;
      margin: 30px 160px 0;
    }
  }
  @media screen and (max-width: 768px){
    .user_info{
      margin: 0;
      padding: 0 20px;
      width: 100%;
      box-sizing: border-box;
    }
    .user_info h3{
      margin-top: 10px;
    }
    .user_info .save_btn{
      margin: 30px 0;
    }
  }
</style>
